module.exports = __webpack_public_path__ + "img/sarah-ruckhofer.363b91c6.jpg";